import React, { Component } from 'react';
import { connect } from 'react-redux';
import SmDetail from 'containers/CompanyManagement/CompanyInfo/Detail';
import { DetailProps } from 'containers/CompanyManagement/CompanyInfo/components/Detail/supplierDetailHOC';
import * as actions from 'modules/actions/lsSupplierManagement';

class Detail extends Component<DetailProps> {
  render() {
    return (
      <SmDetail {...this.props} />
    );
  }
}

const mapStateProps = (state: any, ownProps: any) => {
  const data = state.lsSupplierManagement.detail;
  return {
    data,
  };
};

const mapDispatchToProps = () => {
  return {
    getDetail: actions.getDetail,
  };
};

export default connect(mapStateProps, mapDispatchToProps)(Detail);
